import { GlassCard } from './GlassCard';
import { cn } from '@/lib/cn';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({
  icon = 'inbox',
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <GlassCard
      variant="kinetic"
      padding="lg"
      rounded="none"
      className={cn('text-center', className)}
    >
      <div className="py-16 flex flex-col items-center gap-4">
        <div className="w-20 h-20 flex items-center justify-center bg-surface border-2 border-primary text-primary shadow-[3px_3px_0_0_#ff8a65]">
          <span
            className="material-symbols-outlined text-5xl"
            style={{ fontVariationSettings: "'FILL' 1" }}
          >
            {icon}
          </span>
        </div>
        <h3 className="font-condensed text-3xl uppercase tracking-tight text-text-bright">
          {title}
        </h3>
        {description && (
          <p className="text-text-muted max-w-md mx-auto font-mono text-sm uppercase tracking-wider">
            {description}
          </p>
        )}
        {action && <div className="mt-4">{action}</div>}
      </div>
    </GlassCard>
  );
}
